/* global gsap */

// Element that you want the scroll progress tied to
const targets = gsap.utils.toArray('[data-element="fade-parent"]');

if (targets && targets.length > 0) {
  targets.forEach((target) => {
    // Elements within the parent that you want to animate
    const fadeInUp = target.querySelectorAll('[data-element="fade-in-up"]');
    const fadeInRight = target.querySelectorAll('[data-element="fade-in-right"]');
    const fadeInLeft = target.querySelectorAll('[data-element="fade-in-left"]');

    const scrollTrigger = {
      trigger: target,
      scrub: 1,
      start: 'top bottom-=200',
      end: 'top top+=100',
      toggleActions: 'restart pause resume pause',
    };

    if (fadeInUp && fadeInUp.length > 0) {
      gsap.to(fadeInUp, {
        opacity: 1,
        y: 0,
        stagger: {
          each: 0.25,
        },
        scrollTrigger,
      });
    }

    if (fadeInRight && fadeInRight.length > 0) {
      gsap.to(fadeInRight, {
        opacity: 1,
        x: 0,
        stagger: {
          each: 0.25,
        },
        scrollTrigger,
      });
    }

    if (fadeInLeft && fadeInLeft.length > 0) {
      gsap.to(fadeInLeft, {
        opacity: 1,
        x: 0,
        stagger: {
          each: 0.25,
        },
        scrollTrigger,
      });
    }
  });
}

// Targeting first item in page for certain modules
const loadReveal = document.querySelector('[data-element="fade-load-reveal"]');

if (loadReveal) {
  const fadeChildren = loadReveal.querySelectorAll('[data-element="fade-in-up"]');

  if (fadeChildren && fadeChildren.length > 0) {
    gsap.to(fadeChildren, {
      opacity: 1,
      y: 0,
      stagger: {
        each: 0.2,
      },
    });
  }
}


// Image transition
const imgWipe = gsap.utils.toArray('.img-wipe-mask');

if (imgWipe && imgWipe.length > 0) {
  imgWipe.forEach((img) => {
    const rectOdd = img.querySelectorAll('rect:nth-child(odd)');
    const rectEven = img.querySelectorAll('rect:nth-child(even)');

    const imgTl = gsap.timeline({
      scrollTrigger: {
        trigger: img,
        start: 'top center',
        once: true,
      },
    });

    imgTl.to(rectOdd, {
      y: '-105%',
      duration: 0.3,
      ease: 'power1.inOut',
      stagger: {
        each: 0.1,
      },
    }).to(rectEven, {
      duration: 0.3,
      y: '105%',
      ease: 'power1.inOut',
      stagger: {
        each: 0.1,
      },
    }, '<+=0.2');
  });
}
